export var Dir;
(function (Dir) {
    Dir[Dir["Up"] = 0] = "Up";
    Dir[Dir["Down"] = 1] = "Down";
    Dir[Dir["Left"] = 2] = "Left";
    Dir[Dir["Right"] = 3] = "Right";
})(Dir || (Dir = {}));
export class Dirs {
    static cornersInDirection(dir) {
        // What we have to multiply the width and height by to get the corners of an rectangle if the given direction.
        switch (dir) {
            case Dir.Up:
                return [{ x: 0, y: 0 }, { x: 1, y: 0 }];
            case Dir.Down:
                return [{ x: 0, y: 1 }, { x: 1, y: 1 }];
            case Dir.Left:
                return [{ x: 0, y: 0 }, { x: 0, y: 1 }];
            case Dir.Right:
                return [{ x: 1, y: 0 }, { x: 1, y: 1 }];
            default:
                // Every corner
                return [{ x: 0, y: 0 }, { x: 1, y: 0 }, { x: 0, y: 1 }, { x: 1, y: 1 }];
        }
    }
}
export var FacingDir;
(function (FacingDir) {
    FacingDir[FacingDir["Left"] = 0] = "Left";
    FacingDir[FacingDir["Right"] = 1] = "Right";
})(FacingDir || (FacingDir = {}));
